/* This file is autogenerated, see readme.md for instructions */
import PercentageSvgIcon from '@bloomreach/banana-theme/icons/percentage.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PercentageIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PercentageSvgIcon />
    </Icon>
  );
});

PercentageIcon.displayName = 'PercentageIcon';

export default PercentageIcon;
